import { getHttpService } from '@strata/core/lib';
import { IEmail, IOrgPinPrompt } from './IEmail';

const { httpPost } = getHttpService(window.location.origin, () =>
  Promise.resolve({
    credentials: 'same-origin'
  })
);

export const EmailFormService = {
  postEmail: (username: string): Promise<IEmail> =>
    httpPost<IEmail>(`/api/initiateLogin${window.location.search}`, username, {
      headers: new Headers({
        'Content-Type': 'application/json; charset=utf-8'
      })
    }),

  postOrgpin: (username: string, orgPin: string): Promise<IOrgPinPrompt> =>
    httpPost<IOrgPinPrompt>(`/api/externalRedirectFromOrgPin${window.location.search}&orgPin=${orgPin}&username=${username}`, {
      headers: new Headers({
        'Content-Type': 'application/json; charset=utf-8'
      })
    })
};
